import { render } from "./TaskConfirmationDialog.vue?vue&type=template&id=29aa8a61"
import script from "./TaskConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./TaskConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__